module.exports = __webpack_public_path__ + "img/other_en.de0fccd1.svg";